const recommendationWrapper = document.querySelector('[alternate-products]');
const productRecommendationsSectionSwiper = document.querySelector('[oos-recommendations]');
if (productRecommendationsSectionSwiper) {
    const product_id = productRecommendationsSectionSwiper.getAttribute('data-product-id');
    const section_name = "gb-product-recommended-products";
    fetch(window.Shopify.routes.root + `recommendations/products?product_id=${product_id}&limit=4&section_id=${section_name}&intent=related`)
        .then(response => response.text())
        .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const card_wrapper = html.querySelector('.recommendations-wrapper');
            const rec_count = parseInt(card_wrapper.getAttribute('data-rec-count'));

            if (rec_count === 0) {
                console.log("No recommendations found");
                return;
            }

            if (productRecommendationsSectionSwiper) {
                productRecommendationsSectionSwiper.innerHTML = card_wrapper.innerHTML;
            }

            // Initialize Swiper after updating the HTML
            new window.swiper('.alternatives-products-slider', {
                slidesPerView: 1.2,
                spaceBetween: 44,
                breakpoints: {
                    450: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    1028: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                    1280: {
                        slidesPerView: 5,
                        spaceBetween: 20,
                    },
                },
                navigation: {
                    nextEl: '.alternatives-products-swiper-button-next',
                    prevEl: '.alternatives-products-swiper-button-prev',
                },
            });

            recommendationWrapper.classList.add('show');
        })
        .catch(error => {
            console.error('Error fetching recommendations:', error);
        });
} else {
    console.log("No product recommendations section found");
}
